import PluginInterface from "./PluginInterface";
import Sdk from "../Sdk";
import { PluginControlPosition } from "../../types/player";

export default class PluginContainer {
    
    plugin: PluginInterface;
    sdk: Sdk;

    constructor(plugin: any, sdk: Sdk) {
        this.plugin = plugin;
        this.sdk = sdk;
    }

    determinePositionofControl(name: string, positionOfControl: PluginControlPosition): PluginControlPosition {   
        if(this.plugin.positionsOfControls) {
            for(let i in this.plugin.positionsOfControls) {
                if(this.plugin.positionsOfControls[i].name == name) {
                    positionOfControl = this.plugin.positionsOfControls[i].position as PluginControlPosition;
                }            
            }
        }
        return positionOfControl;    
    }

    addControl(name: string, controlPosition: PluginControlPosition) {
        this.sdk.options().getControls().addPluginControl(
            this.plugin.getName(), 
            name, 
            this.determinePositionofControl(name, controlPosition),
            this.plugin
        );
    }

    getName() {
        return this.plugin.getName();
    }

    
}